// extracted by mini-css-extract-plugin
export default {"container_modal":"styles_container_modal__UYfAR","content_modal":"styles_content_modal__MG1uy","modal_buttons":"styles_modal_buttons__i-0Kc"};